export default "__VITE_ASSET__BNToUnTG__"